import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Contact } from '@ztechapps/common.contract'
import { HaulerLogo } from './HaulerLogo'
import { HaulerPlant } from '@ztechapps/totalmilk-tmms.common'

@ObjectType()
export class MilkPickupRouteCustomerRef {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  type?: string

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => HaulerPlant, { nullable: true })
  @Prop({ type: HaulerPlant })
  plant?: ReturnType<() => HaulerPlant>
}
